import { DashboardCard } from '@/common/dashboard/DashboardCard';
import { DateUtils } from '@/common/utils/DateUtils';
import { Stack, Typography } from '@mui/material';

export const OverallStatusCard = () => {
  return (
    <DashboardCard
      title="Overall Status"
      description="Displays whether every selected test suite passed on its most recent run"
    >
      {(data) => {
        const suitePassCount = data.suites.filter((suite) => suite.status === 'SUCCESS').length;
        const allSuitesPass = data.suites.length > 0 && suitePassCount === data.suites.length;
        const oneTestRan = data.tests.pass + data.tests.fail > 0;

        const label =
          allSuitesPass ? 'PASS'
          : oneTestRan ? 'FAIL'
          : 'N/A';
        const color =
          allSuitesPass ? 'success.main'
          : oneTestRan ? 'error.main'
          : 'text.secondary';

        return (
          <Stack gap={1} height="100%">
            <Typography variant="h3" sx={{ fontWeight: 700, color }}>
              {label}
            </Typography>
            <Typography variant="body2" color="text.secondary">
              {suitePassCount} of {data.suites.length} suites passing
            </Typography>
            <Typography variant="caption" color="text.secondary">
              Last Run: {data.runTsISO ? DateUtils.convertUtcToLocal(data.runTsISO) : 'N/A'}
            </Typography>
          </Stack>
        );
      }}
    </DashboardCard>
  );
};
